// NPM Modules
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';

// Components
import Home from './components/Home';
import AccountLink from './components/AccountLink';
import AlmostThere from './components/AlmostThere';
import VerifyEmail from './components/VerifyEmail';

ReactDOM.render(
  <Router history={browserHistory}>

    <Route path="/" component={Home} />
    <Route path="/link-account" component={AccountLink} />
    <Route path="/almost-there" component={AlmostThere} />
    <Route path="/verify-email" component={VerifyEmail} />

    <Route path="*" component={Home} />

  </Router>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js